import React, { Component } from 'react';
import moment from 'moment';

import AutoZoneDetectionsModel from './AutoZoneDetectionsModel';
import AutoZoneDetectionsTableExpander from './AutoZoneDetectionsTableExpander';

import { Table, Popconfirm, Row, Col } from 'antd';

class AutoZoneDetectionsTable extends Component {

  state = {
    children: []
  }

  columns = [{
    title: 'Lokalita',
    dataIndex: 'ParkingLocationName',
    key: 'ParkingLocationName',
  }, {
    title: 'Čas detekce',
    dataIndex: 'Timestamp',
    key: 'Timestamp',
    render: (text, record) => (
      <span>{text ? moment(text).format('LLLL') : null}</span>
    ),
    defaultSortOrder: 'descend',
    sorter: (a, b) => {
      return (a.Timestamp < b.Timestamp) ? -1 : ((a.Timestamp > b.Timestamp) ? 1 : 0);
    }
  }]

  onClickImg(base64data) {
    var newTab = window.open('', '_blank', "menubar=no,status=no,titlebar=no,location=no,toolbar=no,scrollbars=yes,resizable=yes,top=50,left=500,width=800,height=600");
    newTab.document.body.innerHTML = '<img src="' + base64data + '">';
  }

  expandedRowRender(record) {
    return (
      <div>
        <AutoZoneDetectionsTableExpander images={record.Images} />
      </div>
    );
  }
  
  render() {
    return (
      <Table
        size='small'
        rowKey={this.props.rowKey ? this.props.rowKey : 'id'}
        loading={this.props.loading ? this.props.loading : false}
        columns={this.columns}
        dataSource={this.props.data}
        style={{ border: '0px' }}
        expandedRowRender={this.expandedRowRender.bind(this)} />
    );
  }
}

export default AutoZoneDetectionsTable;


// WEBPACK FOOTER //
// ./src/components/AutoZoneDetectionsTable.js